import notify from '@/js/helpers/notify.js';

const setClipboard = (text, message) => {
  var dummy = document.createElement('textarea');
  document.body.appendChild(dummy);
  dummy.value = text;
  dummy.select();
  document.execCommand('copy');
  document.body.removeChild(dummy);

  notify({ text: message, duration: 2000 });
};

export { setClipboard };
